// Type declaration
declare global {
  interface String {
    capitalizeWords(): string;
  }
}

function capitalizeWords(this: string): string {
  return this.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
}

String.prototype.capitalizeWords = capitalizeWords;


export { capitalizeWords };
